var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngleCircleUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1996_127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 28C16.7689 28 19.4757 27.1789 21.778 25.6406C24.0803 24.1022 25.8747 21.9157 26.9343 19.3576C27.9939 16.7994 28.2712 13.9845 27.731 11.2687C27.1908 8.553 25.8574 6.05844 23.8995 4.1005C21.9416 2.14257 19.447 0.809198 16.7313 0.269005C14.0155 -0.271189 11.2006 0.00605965 8.64242 1.06569C6.08426 2.12531 3.89776 3.91973 2.35942 6.22202C0.821077 8.5243 -9.53674e-06 11.2311 -9.53674e-06 14C0.00400543 17.7118 1.48029 21.2704 4.10493 23.8951C6.72957 26.5197 10.2882 27.996 14 28ZM14 9.33333C14.854 9.33246 15.6787 9.64458 16.3182 10.2107C16.6997 10.5502 17.0613 10.8803 17.2982 11.1172L20.65 14.4118C20.8563 14.6314 20.9696 14.9222 20.9663 15.2235C20.963 15.5247 20.8433 15.813 20.6322 16.028C20.4212 16.243 20.1351 16.368 19.834 16.3768C19.5329 16.3857 19.24 16.2777 19.0167 16.0755L15.6567 12.775C15.4373 12.5568 15.1107 12.2605 14.7712 11.9583C14.558 11.7703 14.2836 11.6666 13.9994 11.6666C13.7152 11.6666 13.4408 11.7703 13.2277 11.9583C12.8893 12.2593 12.5627 12.5557 12.3503 12.7668L8.98333 16.0755C8.87571 16.1901 8.74605 16.2817 8.60214 16.3449C8.45823 16.4081 8.30303 16.4415 8.14587 16.4433C7.9887 16.445 7.83281 16.415 7.68754 16.3549C7.54228 16.2949 7.41064 16.2062 7.30052 16.094C7.19041 15.9819 7.1041 15.8486 7.04676 15.7023C6.98943 15.5559 6.96225 15.3995 6.96687 15.2424C6.97149 15.0853 7.00781 14.9307 7.07365 14.788C7.13948 14.6453 7.23348 14.5173 7.34999 14.4118L10.7088 11.1113C10.9422 10.878 11.3003 10.5513 11.6807 10.2142C12.3197 9.64626 13.1451 9.33281 14 9.33333Z",
    fill: "#5DB8E2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1996_127"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "matrix(-1 0 0 -1 28 28)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleCircleUp);
export default __webpack_public_path__ + "static/media/AngleCircleUp.b940666ed1ebe3d1843c78b9b1b9254a.svg";
export { ForwardRef as ReactComponent };